import {
  Alert,
  Backdrop,
  CircularProgress,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useReducer, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../../../CustomComponents/CustomButton";
import CustomConfirmationDialog from "../../../CustomComponents/CustomConfirmationDialog";
import DisbursementTabIntegrator from "../Disbursement_Common/DisbursementTabIntegrator";
import { SpecialAccessDetailAction } from "../../../Store/SpecialAccess/SpecialAccessDetailReducer";
import NoSpecialAccess from "../../../CustomComponents/NoSpecialAccess";
import StlapFooter from "../../../CustomComponents/StlapFooter";
import store from "../../../Store";
import { DisbursementBalanceTransferReducerAction } from "../../../Store/DisbursementBalanceTransfer/DisbursementBalanceTransferReducer";
import GetBranchDetailsWithCode from "../../../CustomComponents/GetBranchDetailsWithCode";
import { CommonShortCutAction } from "../../../Store/CommonShortCutsReducer";
import { useRef } from "react";
import { DisbursementLosCustomerDataReducerAction } from "../../../Store/DisbursementLosCustomerData/DisbursementLosCustomerDataReducer";

var today = new Date();
var todayDate =
  today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear();

var disbursementDetailsInitialState = {
  applicationNum: "",
  billingDate: "",
  billDay: "-1",
  dateOfDisb: todayDate,
  disbAmt: 0,
  disbCycleNum: 0,
  transactionKey: 0,
  disbHeaderKey: 0,
  disbursementFavours: [],
  earlierDisbAmt: 0,
  editLock: false,
  effectiveDate: todayDate,
  emiCommDate: dayjs(today).format("MM/DD/YYYY"),
  firstEmiDueDate: "-1",
  paymentMode: "",
  remarks: "",
  approvalRemarks: "",
  requestStatus: "",
  screenMode: "CREATE",
  shflBank: "",
  totalDisbAmt: 0,
  rateOfInterest: 0,
  totalDeductionAmt: 0,
  disbEmiAmt: 0,
  sanctionedEmiAmt: 0,
};

const DisbursementCreate = (props) => {
  var today = new Date();
  var currentDateValue = new Date(today.setHours(0, 0, 0, 0));

  const [billDayValues, setbillDayValues] = useState([]);
  const [deductionTabValue, setdeductionTabValue] = useState({});
  const [pageloading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );
  const [showConfirmation, setshowConfirmation] = useState(false);
  const [showGeneratedNumber, setshowGeneratedNumber] = useState(false);
  const [saveData, setsaveData] = useState([]);
  const [requestNumber, setrequestNumber] = useState(0);
  const [disableCreate, setdisableCreate] = useState(false);
  const [parameterValues, setparameterValues] = useState({});
  const [feeDataResponse, setfeeDataResponse] = useState({});
  let firstDisbData = null;
  const userName = useSelector((state) => state.branch.userName);
  const [historyData, setHistorydata] = useState({});
  const [disbCycleNum, setDisbCycleNum] = useState(0);

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const deleteOperationActive = useSelector(
    (state) => state.disbursementBalanceTransfer.deleteOperationActive
  );
  const totalDeductionsTabLoadingActive = useSelector(
    (state) => state.disbursementBalanceTransfer.totalDeductionsTabLoadingActive
  );

  const losCustomerData = useSelector(
    (state) => state.disbursementLosCustomerData.losCustomerData
  );
  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const dispatchAction = useDispatch();

  //shortcut key
  const backRef = useRef(null);
  const saveRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      backRef: backRef,
      saveRef: saveRef,
    };
    if (event.ctrlKey) {
      dispatchAction(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "disbursementCreate",
        })
      );
      //}
    }
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatchAction(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "disbursementCreate",
        })
      );
    }
  };
  const screenFields = {
    applicationNum: "applicationNum",
    billingDate: "billingDate",
    billDay: "billDay",
    dateOfDisb: "dateOfDisb",
    disbAmt: "disbAmt",
    disbCycleNum: "disbCycleNum",
    transactionKey: "transactionKey",
    disbHeaderKey: "disbHeaderKey",
    disbursementFavours: "disbursementFavours",
    earlierDisbAmt: "earlierDisbAmt",
    editLock: "editLock",
    effectiveDate: "effectiveDate",
    emiCommDate: "emiCommDate",
    firstEmiDueDate: "firstEmiDueDate",
    paymentMode: "paymentMode",
    remarks: "remarks",
    approvalRemarks: "approvalRemarks",
    requestStatus: "requestStatus",
    shflBank: "shflBank",
    totalDisbAmt: "totalDisbAmt",
    transactionId: "transactionId",
    screenMode: "screenMode",
    rateOfInterest: "rateOfInterest",
    totalDeductionAmt: "totalDeductionAmt",
    listChange: "listChange",
    disbEmiAmt: "disbEmiAmt",
    sanctionedEmiAmt: "sanctionedEmiAmt",
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case screenFields.billingDate:
        return { ...state, billingDate: action.value };
      case screenFields.billDay:
        return { ...state, billDay: action.value };
      case screenFields.dateOfDisb:
        return { ...state, dateOfDisb: action.value };
      case screenFields.disbAmt:
        return { ...state, disbAmt: action.value };
      case screenFields.disbCycleNum:
        return { ...state, disbCycleNum: action.value };
      case screenFields.transactionKey:
        return { ...state, transactionKey: action.value };
      case screenFields.disbursementFavours:
        return { ...state, disbursementFavours: action.value };
      case screenFields.earlierDisbAmt:
        return { ...state, earlierDisbAmt: action.value };
      case screenFields.editLock:
        return { ...state, editLock: action.value };
      case screenFields.effectiveDate:
        return { ...state, effectiveDate: action.value };
      case screenFields.emiCommDate:
        const dateValue = action.value
          ? dayjs(action.value).format("MM/DD/YYYY")
          : null;
        return { ...state, emiCommDate: dateValue };
      case screenFields.firstEmiDueDate:
        return { ...state, firstEmiDueDate: action.value };
      case screenFields.paymentMode:
        return { ...state, paymentMode: action.value };
      case screenFields.remarks:
        return { ...state, remarks: action.value };
      case screenFields.approvalRemarks:
        return { ...state, approvalRemarks: action.value };
      case screenFields.requestStatus:
        return { ...state, requestStatus: action.value };
      case screenFields.shflBank:
        return { ...state, shflBank: action.value };
      case screenFields.totalDisbAmt:
        return { ...state, totalDisbAmt: action.value };
      case screenFields.screenMode:
        return { ...state, screenMode: action.value };
      case screenFields.rateOfInterest:
        return { ...state, rateOfInterest: action.value };
      case screenFields.totalDeductionAmt:
        return { ...state, totalDeductionAmt: action.value };
      case screenFields.disbHeaderKey:
        return { ...state, disbHeaderKey: action.value };
      case screenFields.disbEmiAmt:
        return { ...state, disbEmiAmt: action.value };
      case screenFields.sanctionedEmiAmt:
        return { ...state, sanctionedEmiAmt: action.value };
      case screenFields.listChange:
        return { ...action.value };
      default:
        return { ...disbursementDetailsInitialState };
    }
  };
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  const modeIdValue = "DB01-C";

  const getModeData = async () => {
    const response = await axios.get("/specialAccess/getModeSpecialAccess", {
      method: "get",
      params: {
        userId: userId,
        programId: programId,
        modeId: modeIdValue,
      },
    });
    dispatchAction(SpecialAccessDetailAction.getModeData(response.data));
  };

  const modeAccessMap = useSelector(
    (state) => state.specialAccess.modeAccessMap
  );

  const viewValue = modeAccessMap && modeAccessMap.disbursementView;
  const [disbursementDetailTabValue, dispatch] = useReducer(
    reducer,
    disbursementDetailsInitialState
  );
  const errorParameters = {
    currentDisbError: "currentDisbError",
    roiError: "roiError",
    feddError: "feddError",
    billDayError: "billDayError",
    shflBankError: "shflBankError",
    bankAccountError: "bankAccountError",
    dateOfDisbError: "dateOfDispError",
    overAllError: "overAllError",
    remarksError: "remarksError",
    approvalRemarksError: "approvalRemarksError",
  };

  const errorInitialState = {
    currentDisbError: [false, "Current Disbursement Amount Cannot be Zero."],
    roiError: [false, "Rate of Interest Cannot be Empty/Zero."],
    feddError: [false, "Please Select Billing Date."],
    billDayError: [false, "Please Select Billing Day."],
    shflBankError: [false, "SHFL Bank Cannot be Empty."],
    bankAccountError: [false, ""],
    dateOfDisbError: [false, "Please Select Date of Disbursement"],
    overAllError: false,
    approvalRemarksError: [
      false,
      "Please Enter Approval Remarks less than 4000 characters.",
    ],
    remarksError: [false, "Please Enter Remarks less than 4000 characters."],
  };

  const errorReducer = (state, action) => {
    switch (action.type) {
      case errorParameters.currentDisbError:
        return { ...state, currentDisbError: action.value };
      case errorParameters.roiError:
        return { ...state, roiError: action.value };
      case errorParameters.feddError:
        return { ...state, feddError: action.value };
      case errorParameters.billDayError:
        return { ...state, billDayError: action.value };
      case errorParameters.shflBankError:
        return { ...state, shflBankError: action.value };
      case errorParameters.bankAccountError:
        return { ...state, bankAccountError: action.value };
      case errorParameters.dateOfDisbError:
        return { ...state, dateOfDisbError: action.value };
      case errorParameters.overAllError:
        return { ...state, overAllError: action.value };
      case errorParameters.remarksError:
        return { ...state, remarksError: action.value };
      case errorParameters.approvalRemarksError:
        return { ...state, approvalRemarksError: action.value };
      default:
        return { ...errorInitialState };
    }
  };

  const [errorState, errorDispatch] = useReducer(
    errorReducer,
    errorInitialState
  );

  useEffect(() => {
    getCustomerDataByAppNum();
    getModeData();
    getBillingDayData();
    getParameterValues();
    dispatch({
      type: screenFields.screenMode,
      value: props.screenMode,
    });
    setTimeout(() => {
      setPageLoading(false);
      setLoading(false);
      setLoadingMsg("");
    }, 500);
    return () => {
      // on component unmount reset the balance transfer records.
      dispatchAction(
        DisbursementLosCustomerDataReducerAction.resetToInitialState()
      );
      dispatchAction(DisbursementBalanceTransferReducerAction.resetGridRows());
      dispatchAction(
        DisbursementBalanceTransferReducerAction.resetToInitialState()
      );
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
          null
        )
      );
    };
  }, []);

  const getBillingDayData = async () => {
    // const response = await axios.get(
    //   "/disbursement/getAllDisbursementBillingDayData"
    // );
    // Instead of getting values from Disbursement API we should get the values from the LOV MASTER API.
    const disbursementLovValues = await axios.post("/lovMaster/getLovValues", {
      moduleId: "MD001",
    });
    const lovData = disbursementLovValues.data;
    const billDayValues = lovData?.["Billing Day"].map((billDay) => {
      return {
        id: billDay.lovOrder,
        value: billDay.lovValues,
        text: billDay.lovValues,
      };
    });
    setbillDayValues(billDayValues);
  };

  const getCustomerDataByAppNum = async () => {
    const response = await axios.post("/losCustomer/getCustomerDataByAppNum", {
      applicationNum: location.state.applicationNum,
    });
    if (response.status === 200) {
      dispatchAction(
        DisbursementLosCustomerDataReducerAction.setLosCustomerData(
          response.data
        )
      );
      const disbResponse = await axios.post(
        "/disbursement/getMaxDisbCycleByAppNum",
        {
          applicationNum: location.state.applicationNum,
        }
      );
      dispatch({
        type: screenFields.disbCycleNum,
        value: disbResponse.data.disbCycleNum,
      });
      if (disbResponse.data.disbCycleNum === 1) {
        dispatch({
          type: screenFields.disbAmt,
          value: response.data.sanctionAmt,
        });
        getDeductionTabData();
      } else {
        const response1 = await axios.post(
          "/disbursement/getFirstDisbByAppNum",
          {
            applicationNum: location.state.applicationNum,
          }
        );
        if (response1.status === 200) {
          let earlierDisbAmt = 0;

          response1.data.map((disbursementRow) => {
            earlierDisbAmt = earlierDisbAmt + disbursementRow.disbAmt;
          });

          let secondDispAmt = response.data.sanctionAmt - earlierDisbAmt;
          dispatch({
            type: screenFields.disbAmt,
            value: secondDispAmt,
          });
          dispatch({
            type: screenFields.earlierDisbAmt,
            value: earlierDisbAmt,
          });
          dispatch({
            type: screenFields.billDay,
            value: response1.data[0].billDay,
          });
          dispatch({
            type: screenFields.billingDate,
            value: response1.data[0].billingDate,
          });
          dispatch({
            type: screenFields.emiCommDate,
            value: response1.data[0].emiCommDate,
          });
          dispatch({
            type: screenFields.firstEmiDueDate,
            value: response1.data[0].firstEmiDueDate,
          });
          dispatch({
            type: screenFields.transactionKey,
            value: response1.data[0].transactionKey,
          });
          getDeductionTabData();
        }
      }
      setSanctionedEmiAmount(response.data);
    }
  };

  const setSanctionedEmiAmount = (losData) => {
    let time = losData.tenure;
    // yearly rate of interest
    let rateOfInterest = losData.rateOfInterest;
    // monthly converted rate of interest
    rateOfInterest = rateOfInterest / (12 * 100);
    let montlyPayment =
      (losData.sanctionAmt *
        rateOfInterest *
        Math.pow(1 + rateOfInterest, time)) /
      (Math.pow(1 + rateOfInterest, time) - 1);
    dispatch({
      type: screenFields.sanctionedEmiAmt,
      value: Math.ceil(montlyPayment),
    });
  };

  const getDeductionTabData = async () => {
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductions(0)
    );
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductionsTabLoadingActive(
        true
      )
    );
    const response = await axios.post("/additionalfee/getFeeData", {
      applicationNum: location.state.applicationNum,
      type: "accrual",
    });
    let paidTotal1 = 0;
    let dueTotal1 = 0;
    let deductionTotal1 = 0;
    let waivedTotal1 = 0;
    let data = {};
    setfeeDataResponse(response.data);
    response.data.gridData.map((rows) => {
      data = {};
      paidTotal1 = paidTotal1 + rows.received;
      dueTotal1 = dueTotal1 + rows.receiveable;
      deductionTotal1 =
        deductionTotal1 + (rows.receiveable - rows.received - rows.earlyWaiver);
      waivedTotal1 = waivedTotal1 + rows.earlyWaiver;
    });
    data.paidTotal = paidTotal1;
    data.dueTotal = dueTotal1 - data.paidTotal;
    data.deductionTotal = deductionTotal1;
    data.waivedTotal = waivedTotal1;
    data.accrualTotal = 0;
    data.gridRows = response.data.gridData;
    dispatch({
      type: screenFields.totalDeductionAmt,
      value: Number(data.deductionTotal) <= 0 ? 0 : data.deductionTotal,
    });
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductions(
        Number(data.deductionTotal) <= 0 ? 0 : data.deductionTotal
      )
    );
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductionsTabLoadingActive(
        false
      )
    );
    setdeductionTabValue(data);
  };

  const getParameterValues = async () => {
    const response = await axios.get("/parameter/getAllParameterData");
    const dataMap = {};
    response.data.map((parameter) => {
      dataMap[parameter.paramName] = parameter;
    });
    setparameterValues(dataMap);
    dispatchAction(SpecialAccessDetailAction.setParameterData(dataMap));
  };

  const fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "DB01-C";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatchAction(SpecialAccessDetailAction.getFieldData(response.data));
  };

  const validateBalanceTransferGrid = (data, gridAddBtnClick) => {
    let status = true;
    //Validating Balance Transfer Grid.
    errorDispatch({
      type: errorParameters.bankAccountError,
      value: [false, ""],
    });
    let errorMessage = "";

    // get the latest records from store.
    const balanceTransferRecords =
      store.getState().disbursementBalanceTransfer.gridRows;

    if (balanceTransferRecords.length === 0) {
      errorMessage =
        `${errorMessage}` + `${`Please Add Balance Transfer Records.`}\n`;
      errorDispatch({
        type: errorParameters.bankAccountError,
        value: [true, errorMessage],
      });
      status = false;
    } else {
      // balance transfer records > 0
      let errorExist = false;
      balanceTransferRecords.forEach((record) => {
        if (record.favouringName === null || record.favouringName === "") {
          errorExist = true;
        }
        if (
          record.amount === null ||
          record.amount === "" ||
          record.amount === "0" ||
          record.amount === 0
        ) {
          errorExist = true;
        }

        if (record.bankBranchGl === null || record.bankBranchGl === "") {
          errorExist = true;
        }

        if (record.paymentMode === "CHEQUE") {
          if (record.chequeMode === null || record.chequeMode === "") {
            errorExist = true;
          }
          if (record.chequePrintAt === null || record.chequePrintAt === "") {
            errorExist = true;
          }
          if (
            (record.chequePrintAt === null || record.chequePrintAt === "") &&
            (record.chequePrintLocation === null ||
              record.chequePrintLocation === "")
          ) {
            errorExist = true;
          }
          if (
            (record.chequePrintAt === null || record.chequePrintAt === "") &&
            (record.chequeShflLocation === null ||
              record.chequeShflLocation === "")
          ) {
            errorExist = true;
          }
          if (
            record.chequeShflLocation !== null &&
            record.chequeShflLocation !== "" &&
            (record.chequeAllocationMode === null ||
              record.chequeAllocationMode === "")
          ) {
            errorExist = true;
          }
          if (
            record.chequeAllocationMode !== null &&
            record.chequeAllocationMode !== "" &&
            record.chequeAllocationMode !== "AUTO" &&
            (record.bankBranchShflBank === null ||
              record.bankBranchShflBank === "")
          ) {
            errorExist = true;
          }
        } else if (record.paymentMode === "DD") {
          if (record.chequeMode === null || record.chequeMode === "") {
            errorExist = true;
          }
          if (record.chequePrintAt === null || record.chequePrintAt === "") {
            errorExist = true;
          }
          if (record.payableAt === null || record.payableAt === "") {
            errorExist = true;
          }
          if (
            record.bankBranchShflBank === null ||
            record.bankBranchShflBank === ""
          ) {
            errorExist = true;
          }
        } else if (
          record.paymentMode === "NEFT" ||
          record.paymentMode === "RTGS"
        ) {
          if (
            record.bankBranchShflBank === null ||
            record.bankBranchShflBank === ""
          ) {
            errorExist = true;
          }
          if (record.ifscCode === null || record.ifscCode === "") {
            errorExist = true;
          }

          if (record.bankName === null || record.bankName === "") {
            errorExist = true;
          }

          if (record.bankBranchName === null || record.bankBranchName === "") {
            errorExist = true;
          }

          if (record.bankAccountNum === null || record.bankAccountNum === "") {
            errorExist = true;
          }

          if (
            record.bankAccountType === null ||
            record.bankAccountType === ""
          ) {
            errorExist = true;
          }
        }
      });

      if (errorExist) {
        errorMessage =
          `${errorMessage}` + `${`Few Rows has Some Empty Data on Columns.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      // validate the favouring name for Special characters & length > 80.
      let invalidFavouringNameWithSpecialCharExists = false;
      let invalidFavouringNameWithMaxlengthExists = false;
      const specialCharPatternForFavouringName = /[!@#$%^~&*()?,":{}|<>\\\-]/;

      // validate the bank Account number & Ifsc Code.
      let invalidAccountNumExits = false;
      let invalidIfscCodeExist = false;
      balanceTransferRecords.forEach((record) => {
        if (record.paymentMode === "NEFT" || record.paymentMode === "RTGS") {
          const bankAccountNum = record.bankAccountNum;
          if (
            bankAccountNum !== "" &&
            bankAccountNum !== null &&
            bankAccountNum !== undefined &&
            String(bankAccountNum).length <= 18 &&
            String(bankAccountNum).length >= 9 &&
            Number(bankAccountNum) > 0 &&
            !String(bankAccountNum).includes(".") &&
            /^\d+$/.test(bankAccountNum)
          ) {
            invalidAccountNumExits = false;
          } else {
            invalidAccountNumExits = true;
          }

          const ifscCode = record.ifscCode;
          if (
            ifscCode !== "" &&
            ifscCode !== null &&
            ifscCode !== undefined &&
            /^[A-Za-z0-9]*$/.test(ifscCode) &&
            String(ifscCode).length === 11
          ) {
            invalidIfscCodeExist = false;
          } else {
            invalidIfscCodeExist = true;
          }
        }
        // validating the favouring name irrespective of payment mode -> all modes have favouring name as editable.
        const favouringNameValue = record.favouringName;
        if (
          favouringNameValue &&
          specialCharPatternForFavouringName.test(favouringNameValue)
        ) {
          invalidFavouringNameWithSpecialCharExists = true;
        } else {
          invalidFavouringNameWithSpecialCharExists = false;
        }
        if (favouringNameValue && String(favouringNameValue).length > 80) {
          invalidFavouringNameWithMaxlengthExists = true;
        } else {
          invalidFavouringNameWithMaxlengthExists = false;
        }
      });

      if (invalidFavouringNameWithSpecialCharExists) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid Favouring Name with Special Characters.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      if (invalidFavouringNameWithMaxlengthExists) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid Favouring Name with max length Exceeding 80 Characters.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      if (invalidAccountNumExits) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid Bank Account Number.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      if (invalidIfscCodeExist) {
        errorMessage =
          `${errorMessage}` + `${`Few Rows has Invalid Ifsc Code.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      // // validate shfl branch column based on cheque allocation mode.
      // let bankBranchShflBankError = false;
      // balanceTransferRecords.forEach((record) => {
      //   if (
      //     record.chequeAllocationMode !== null &&
      //     record.chequeAllocationMode !== "" &&
      //     record.chequeAllocationMode === "AUTO" &&
      //     record.bankBranchShflBank !== null &&
      //     record.bankBranchShflBank !== ""
      //   ) {
      //     bankBranchShflBankError = true;
      //   }
      // });

      // if (bankBranchShflBankError) {
      //   errorMessage =
      //     `${errorMessage}` +
      //     `${`Few Rows has Invalid Bank Branch ShflBank for cheque Allocation Mode Auto .`}\n`;
      //   errorDispatch({
      //     type: errorParameters.bankAccountError,
      //     value: [true, errorMessage],
      //   });
      //   status = false;
      // }

      // validate the cheque Print Location & cheque Shfl location based on Cheque Print At.
      let chequePrintLocationError = false;
      balanceTransferRecords.forEach((record) => {
        if (
          record.chequePrintAt === "BANK" &&
          record.paymentMode === "CHEQUE" &&
          (record.chequePrintLocation === null ||
            record.chequePrintLocation === "")
        ) {
          chequePrintLocationError = true;
        }
        if (
          record.chequePrintAt === "CORPORATE" &&
          record.chequePrintLocation !== null &&
          record.chequePrintLocation !== ""
        ) {
          chequePrintLocationError = true;
        }

        if (
          record.chequePrintAt === "SHFL BRANCH" &&
          record.chequePrintLocation !== null &&
          record.chequePrintLocation !== ""
        ) {
          chequePrintLocationError = true;
        }
      });

      if (chequePrintLocationError) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid cheque Print Location.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      // cheque Num validation case for cheque mode is Manual & Auto in create mode.

      let chequeNumError = false;
      balanceTransferRecords.forEach((record) => {
        if (record.paymentMode === "CHEQUE") {
          if (
            record.chequeMode === "MANUAL" &&
            (record.chequeNum === null ||
              record.chequeNum === "" ||
              String(record.chequeNum).length > 6)
          ) {
            chequeNumError = true;
          }
        }
      });

      if (chequeNumError) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid cheque Number for Manual Cheque Mode.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      let chequeShflLocationError = false;
      balanceTransferRecords.forEach((record) => {
        if (
          record.chequePrintAt === "SHFL BRANCH" &&
          (record.chequeShflLocation === null ||
            record.chequeShflLocation === "")
        ) {
          chequeShflLocationError = true;
        }

        if (
          record.chequePrintAt === "BANK" &&
          record.chequeShflLocation !== null &&
          record.chequeShflLocation !== ""
        ) {
          chequeShflLocationError = true;
        }
        if (
          record.chequePrintAt === "CORPORATE" &&
          record.chequeShflLocation !== null &&
          record.chequeShflLocation !== ""
        ) {
          chequeShflLocationError = true;
        }
      });

      if (chequeShflLocationError) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid cheque SHFL Location.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      const zeroAmountRows = [...balanceTransferRecords].filter(
        (row) => Number(row.disbAmt) === 0
      );

      if (zeroAmountRows.length > 0) {
        errorMessage = `${errorMessage}` + `${`Few Rows has Zero Amount.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      // RTGS min validation.
      const rtgsAmountErrorRows = [...balanceTransferRecords].filter(
        (row) => row.paymentMode === "RTGS" && Number(row.disbAmt) < 200000
      );

      if (rtgsAmountErrorRows.length > 0) {
        errorMessage =
          `${errorMessage}` +
          `${`Minimum Amount for one RTGS Payment should be greater than 2,00,000 . Few Rows have Invalid Amount.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      if (!gridAddBtnClick) {
        // for grid add btn click -> true skip this validation
        // for create btn click then gridAddBtnClick is -> false , then need to valdiate
        const sumTotalAmount = Number(
          [...balanceTransferRecords]
            .map((row) => Number(row.disbAmt))
            .reduce((a, b) => a + b)
        );
        const totalDisbAmt = data.disbAmt - data.totalDeductionAmt;

        if (sumTotalAmount > totalDisbAmt) {
          errorMessage =
            `${errorMessage}` +
            `${`Total Net Disbursement Amount to be Sent is Greater than `}` +
            `${parseInt(totalDisbAmt).toLocaleString("en-IN")}` +
            `\n`;
          errorDispatch({
            type: errorParameters.bankAccountError,
            value: [true, errorMessage],
          });
          status = false;
        } else if (sumTotalAmount < totalDisbAmt) {
          errorMessage =
            `${errorMessage}` +
            `${`Total Net Disbursement Amount to be Sent is Less than `}` +
            `${parseInt(totalDisbAmt).toLocaleString("en-IN")}` +
            `\n`;
          errorDispatch({
            type: errorParameters.bankAccountError,
            value: [true, errorMessage],
          });
          status = false;
        }
      }
    }
    // before the grid validation result for all rows dispatch the value to the redux store.
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateIsGridRecordsValid(status)
    );
    return status;
  };

  const validateCreateRequestData = (data, losData) => {
    let status = true;

    //Validating Current Disbursement Amount Field
    if (
      data.disbAmt === 0 ||
      data.disbAmt === null ||
      data.disbAmt === "" ||
      data.disbAmt === "0" ||
      data.disbAmt === "00"
    ) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [true, "Current Disbursement Amount Cannot be Zero."],
      });
      status = false;
    } else if (
      Math.floor(data.disbAmt + data.earlierDisbAmt) >
      Math.floor(losData.sanctionAmt)
    ) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [
          true,
          "Sum of Current Disbursement Amount & Earlier Disbursement Amount Cannot be Greater than Sanctioned Loan Amount.",
        ],
      });
      status = false;
    } else if (data.totalDisbAmt <= 0) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [
          true,
          "Current Disbursement Amount Cannot be Less than or Equal to Total Deductions.",
        ],
      });
      status = false;
    } else if (
      parameterValues &&
      Object.keys(parameterValues).length > 0 &&
      parameterValues["Disbursement Minimum Amount"] &&
      new Date(
        parameterValues["Disbursement Minimum Amount"]["paramEffStartDate"]
      ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
      new Date(
        parameterValues["Disbursement Minimum Amount"]["paramEffEndDate"]
      ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
      Math.floor(data.disbAmt) <
        Number(parameterValues["Disbursement Minimum Amount"]["paramValue"])
    ) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [
          true,
          "Current Disbursement Amount Cannot be Less than Minimum Disbursement Amount given in Parameter.",
        ],
      });
      status = false;
    } else if (errorState.currentDisbError[0]) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [false, "Current Disbursement Amount Cannot be Zero."],
      });
    }

    //Validation Date of Disbursement
    errorDispatch({
      type: errorParameters.dateOfDisbError,
      value: [false, "Date of Disbursement Cannot be Empty."],
    });

    let minDateValue = Number(0);
    let maxDateValue = Number(0);
    if (
      parameterValues !== null &&
      parameterValues !== undefined &&
      parameterValues &&
      Object.keys(parameterValues).length > 0
    ) {
      minDateValue =
        fieldAccessMap &&
        (fieldAccessMap.disbursementCreateRequestDateBackCount &&
        parameterValues["Disbursement Create Request Date Back Count"]
          ? Number(
              parameterValues["Disbursement Create Request Date Back Count"][
                "paramValue"
              ]
            )
          : 0);
      maxDateValue =
        fieldAccessMap &&
        (fieldAccessMap.disbursementCreateRequestDateFutureCount &&
        parameterValues["Disbursement Create Request Date Future Count"]
          ? Number(
              parameterValues["Disbursement Create Request Date Future Count"][
                "paramValue"
              ]
            )
          : 0);
    }
    const dateOfDisbValue = data.dateOfDisb;
    let formattedValue = dateOfDisbValue;
    if (dateOfDisbValue === 0 || dateOfDisbValue === null) {
      errorDispatch({
        type: errorParameters.dateOfDisbError,
        value: [true, "Date of Disbursement Cannot be Empty."],
      });
      status = false;
    } else if (new Date(formattedValue).toDateString() === "Invalid Date") {
      errorDispatch({
        type: errorParameters.dateOfDisbError,
        value: [true, "Please Enter Valid Disbursement Date."],
      });
      status = false;
    } else {
      // valid date then go for the validation.
      if (
        new Date(formattedValue) >=
        new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      ) {
        if (
          parameterValues &&
          Object.keys(parameterValues).length > 0 &&
          parameterValues["Disbursement Create Request Date Future Count"] &&
          new Date(
            parameterValues["Disbursement Create Request Date Future Count"][
              "paramEffStartDate"
            ]
          ) <= currentDateValue &&
          new Date(
            parameterValues["Disbursement Create Request Date Future Count"][
              "paramEffEndDate"
            ]
          ) >= currentDateValue &&
          new Date(formattedValue) >
            new Date(new Date().setDate(new Date().getDate() + maxDateValue))
        ) {
          errorDispatch({
            type: errorParameters.dateOfDisbError,
            value: [
              true,
              "Date of Disbursement Cannot be greater than Request Date Future count from Current Date.",
            ],
          });
          status = false;
        } else {
          // check for current disb date out of the effective start & end dates.
          const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));
          if (
            !(
              parameterValues[
                "Disbursement Create Request Date Future Count"
              ] &&
              new Date(
                parameterValues[
                  "Disbursement Create Request Date Future Count"
                ]["paramEffStartDate"]
              ) <= currentDateValue &&
              new Date(
                parameterValues[
                  "Disbursement Create Request Date Future Count"
                ]["paramEffEndDate"]
              ) >= currentDateValue
            ) &&
            new Date(formattedValue).toDateString() !==
              new Date(currentDate).toDateString()
          ) {
            errorDispatch({
              type: errorParameters.dateOfDisbError,
              value: [
                true,
                "Date of Disbursement Cannot be greater than Request Date Future count from Current Date.",
              ],
            });
            status = false;
          }
        }
      } else {
        if (
          parameterValues &&
          Object.keys(parameterValues).length > 0 &&
          parameterValues["Disbursement Create Request Date Back Count"] &&
          new Date(
            parameterValues["Disbursement Create Request Date Back Count"][
              "paramEffStartDate"
            ]
          ) <= currentDateValue &&
          new Date(
            parameterValues["Disbursement Create Request Date Back Count"][
              "paramEffEndDate"
            ]
          ) >= currentDateValue &&
          new Date(formattedValue) <
            new Date(
              new Date(
                new Date().setDate(new Date().getDate() - minDateValue)
              ).setHours(0, 0, 0, 0)
            )
        ) {
          errorDispatch({
            type: errorParameters.dateOfDisbError,
            value: [
              true,
              "Date of Disbursement Cannot be lesser than Request Date Back count from Current Date.",
            ],
          });
          status = false;
        } else {
          // check for current disb date out of the effective start & end dates.
          const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));
          if (
            !(
              parameterValues["Disbursement Create Request Date Back Count"] &&
              new Date(
                parameterValues["Disbursement Create Request Date Back Count"][
                  "paramEffStartDate"
                ]
              ) <= currentDateValue &&
              new Date(
                parameterValues["Disbursement Create Request Date Back Count"][
                  "paramEffEndDate"
                ]
              ) >= currentDateValue
            ) &&
            new Date(formattedValue).toDateString() !==
              new Date(currentDate).toDateString()
          ) {
            errorDispatch({
              type: errorParameters.dateOfDisbError,
              value: [
                true,
                "Date of Disbursement Cannot be lesser than Request Date Back count from Current Date.",
              ],
            });
            status = false;
          }
        }
      }
      // end of date validation.
    }

    //Validating FEDD Field
    if (
      data.firstEmiDueDate === "-1" ||
      data.firstEmiDueDate === null ||
      data.firstEmiDueDate === undefined ||
      data.firstEmiDueDate === ""
    ) {
      errorDispatch({
        type: errorParameters.feddError,
        value: [true, "Please Select FEDD Date."],
      });
      status = false;
    } else if (errorState.feddError[0]) {
      errorDispatch({
        type: errorParameters.feddError,
        value: [false, "Please Select FEDD Date."],
      });
    }

    //Validating Billing  Day Field
    if (
      data.billDay === "-1" ||
      data.billDay === null ||
      data.billDay === undefined ||
      data.billDay === ""
    ) {
      errorDispatch({
        type: errorParameters.billDayError,
        value: [true, "Please Select Billing Day."],
      });
      status = false;
    } else if (errorState.billDayError[0]) {
      errorDispatch({
        type: errorParameters.billDayError,
        value: [false, "Please Select Billing Day."],
      });
    }

    // validating remarks fields length.
    if (data.remarks && String(data.remarks).length > 4000) {
      errorDispatch({
        type: errorParameters.remarksError,
        value: [true, "Please Enter Remarks less than 4000 Characters."],
      });
      status = false;
    } else if (
      data.approvalRemarks &&
      String(data.approvalRemarks).length > 4000
    ) {
      errorDispatch({
        type: errorParameters.approvalRemarksError,
        value: [
          true,
          "Please Enter Approval Remarks less than 4000 Characters.",
        ],
      });
      status = false;
    }

    if (
      losData.creditDeviationStatus !== "Approved" ||
      losData.legalDeviationStatus !== "Approved" ||
      losData.techinicalDeviationStatus !== "Approved" ||
      losData.rcuStatus !== "Approved"
    ) {
      status = false;
    }

    // validating the balance transfer grid.
    const gridValidationStatus = validateBalanceTransferGrid(data, false);
    return status && gridValidationStatus;
  };

  //validation CreditDebitMismatch
  const validateCreditDebitMismatch = async (disbData, losData) => {
    const params = {
      applicationNumber: losData.applicationNum,
      deduction: disbData.totalDeductionAmt,
    };
    try {
      let data;
      const response = await axios.post(
        "disbursement/validateCreditDebitMismatch",
        params
      );
      if (response.data) {
        data = response.data;
      }
      return data;
    } catch (error) {
      setMessage("Unable to proceed due to credit/debit mismatch");
      setAlertType("error");
      openAlertHandler();
      setLoading(false);
      throw new Error("Network error");
    }
  };

  const createRequestHandler = async (data, losData) => {
    data.totalDisbAmt = Math.floor(data.disbAmt) - data.totalDeductionAmt;
    const validateStatus = validateCreateRequestData(data, losData);
    let status = true;
    if (data.disbCycleNum > 1) {
      // validate a disbursement date from backend.
      try {
        const response = await axios.post(
          "/disbursement/disbursementDateValidation",
          {
            branch: losData.branch,
            applicationNum: losData.applicationNum,
            dateOfDisbursement: dayjs(data.dateOfDisb).format("MM/DD/YYYY"),
            disbCycleNum: data.disbCycleNum,
          }
        );
        if (response.status === 206) {
          // error
          errorDispatch({
            type: errorParameters.dateOfDisbError,
            value: [true, response.data],
          });
          status = false;
        }
      } catch (error) {
        status = false;
        setLoading(false);
      }
    }
    const isValid = await validateCreditDebitMismatch(data, losData);
    if (!isValid) {
      setMessage("Unable to proceed due to credit/debit mismatch");
      setAlertType("error");
      openAlertHandler();
      setLoading(false);
    } else if (isValid && validateStatus && status) {
      setLoadingMsg(
        "Validated the Disbursement Data for Creation Successfully....."
      );
      const branchWithCodes = GetBranchDetailsWithCode();
      let balanceTransferRecords =
        store.getState().disbursementBalanceTransfer.gridRows;
      balanceTransferRecords = [...balanceTransferRecords].map((row) => {
        let record = { ...row };
        record.requestStatus = "Requested , Pending For Nach";
        record.applicationNum = losData.applicationNum;
        record.totalDisbAmt = record.amount;
        record.deductionAmount = record.deductionAmount;
        record.disbAmt = record.disbAmt;
        record.accHoldrName = record.favouringName;
        record.createdBy = userName;
        record.createdDate = "";
        record.lastModifiedBy = userName;
        record.lastModifiedDate = "";
        record.disbAccountKey = "";
        record.bankBranch = record.bankBranchShflBank;
        if (record.chequePrintAt === "SHFL BRANCH") {
          record.bankCode = "LFSL095";
          const branchCodeValue = branchWithCodes.find((branch) => {
            return branch.label === record.chequeShflLocation;
          });
          record.branchCode = branchCodeValue.code;
        }
        return record;
      });
      const balanceTransferPaymentMode =
        store.getState().disbursementBalanceTransfer.currentRowPaymentMode;
      const loanType = store.getState().disbursementBalanceTransfer.loanType;
      data.loanType = loanType;
      data.disbursementFavours = balanceTransferRecords;
      data.paymentMode = balanceTransferPaymentMode;
      data.dateOfDisb = new Date(data.dateOfDisb);
      data.effectiveDate = new Date(data.effectiveDate);
      data.applicantName = losData.customerName;
      data.customerId = losData.customerId;
      data.branch = losData.branch;
      const branchCodeValue = branchWithCodes.find((branch) => {
        return branch.code === losData.branchCode;
      });
      data.branchCode = branchCodeValue.code;
      data.voucherNum = null;
      data.applicationNum = losData.applicationNum;
      data.requestStatus = "Requested , Pending For Nach";
      data.processedDate = new Date(today);
      data.createdBy = userName;
      data.lastModifiedBy = userName;
      const validatedData = [];
      validatedData.push(data);
      validatedData.push(losData);
      setTimeout(() => {
        setLoading(false);
        setsaveData(validatedData);
        setshowConfirmation(true);
      }, 1000);
    } else {
      setLoading(false);
    }
  };

  const updateSecondDisbursementData = async (data, losData) => {
    setLoadingMsg(
      "Please Wait Processing Disbursement Data for Creation ....."
    );
    setdisableCreate(true);
    data.requestStatus = "Requested , Nach Approved";
    try {
      const response = await axios.post(
        "/disbursement/updateDisbursement",
        data
      );
      if (response.status === 200) {
        setLoadingMsg(
          "Disbursement Created Successfully and updating Application Status....."
        );
        const updateModel = {
          applicationNum: losData.applicationNum,
          disbCycleNum: 2,
          losStatus: "Requested",
          userName: userName,
        };

        const response1 = await axios.post(
          "/losCustomer/updateCustomerData",
          updateModel
        );
        if (response1.status === 200) {
          setTimeout(() => {
            setshowGeneratedNumber(true);
            setrequestNumber(response.data.transactionKey);
            setLoading(false);
            setdisableCreate(false);
          }, 2000);
        }
      } else if (response.status === 206) {
        setMessage("Disbursement Already Created for this Application.");
        setAlertType("error");
        openAlertHandler();
        setLoading(false);
        setdisableCreate(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      setdisableCreate(false);
    }
  };

  const insertDisbursementDataToDB = async (data, losData) => {
    setLoadingMsg(
      "Please Wait Processing Disbursement Data for Creation ....."
    );
    setdisableCreate(true);
    try {
      const response = await axios.post(
        "/disbursement/insertDisbursement",
        data
      );
      if (response.status === 200) {
        setLoadingMsg(
          "Disbursement Created Successfully and updating Application Status....."
        );
        let updateModel = {};
        if (data.disbAmt === losData.sanctionAmt) {
          updateModel = {
            applicationNum: losData.applicationNum,
            disbCycleNum: 1,
            losStatus: "Requested",
            userName: userName,
          };
        } else {
          updateModel = {
            applicationNum: losData.applicationNum,
            disbCycleNum: 2,
            losStatus: "Requested",
            userName: userName,
          };
        }

        const response1 = await axios.post(
          "/losCustomer/updateCustomerData",
          updateModel
        );
        if (response1.status === 200) {
          setTimeout(() => {
            setshowGeneratedNumber(true);
            setrequestNumber(response.data.transactionKey);
          }, 1000);
        }
      } else if (response.status === 206) {
        setMessage("Disbursement Already Created for this Application.");
        setAlertType("error");
        openAlertHandler();
      }
      setdisableCreate(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      setdisableCreate(false);
    }
  };

  const confirmationOkClickHandler = async () => {
    setLoading(true);
    setLoadingMsg("Processing Disbursement Data for Creation .....");
    const disbResponse = await axios.post(
      "/disbursement/getMaxDisbCycleByAppNum",
      {
        applicationNum: location.state.applicationNum,
      }
    );
    setDisbCycleNum(disbResponse.data.disbCycleNum);
    setshowConfirmation(false);
    if (disbResponse.data.disbCycleNum > 1) {
      updateSecondDisbursementData(saveData[0], saveData[1]);
    } else {
      insertDisbursementDataToDB(saveData[0], saveData[1]);
    }
    saveAccrualDetails();
  };

  const processEnach = async (disbCycleNum, data) => {
    let newAxiosBaseValue = { ...axios };
    newAxiosBaseValue.defaults.baseURL =
      process.env.REACT_APP_STLAP_LMS_BACKEND;
    if (disbCycleNum === 1) {
      let requestResponse = await newAxiosBaseValue.post(
        "/disbursement/getDataForEnach",
        {
          applicationNum: losCustomerData.applicationNum,
          dataModel: data,
        }
      );
      let newAxiosBase = { ...axios };
      newAxiosBase.defaults.baseURL =
        process.env.REACT_APP_ENACH_BACKEND_SERVER;
      let response = await newAxiosBase.post(
        "/enach/insertDataToEnach",
        requestResponse.data
      );
      if (response.status === 200) {
        setMessage("Mail Sent SuccessFully");
        setAlertType("success");
        openAlertHandler();
        setTimeout(() => {
          navigate("/stlap/home/disbursementCreatePortal", {
            replace: true,
          });
        }, 1000);
      } else {
        console.log("Fail to send a mail");
        setMessage("Fail to send a mail");
        setAlertType("Error");
        openAlertHandler();
        setTimeout(() => {
          navigate("/stlap/home/disbursementCreatePortal", {
            replace: true,
          });
        }, 1000);
      }
    } else {
      navigate("/stlap/home/disbursementCreatePortal", {
        replace: true,
      });
    }
  };

  const saveAccrualDetails = async () => {
    if (deductionTabValue.accrualTotal > 0) {
      const dataMap = {};
      dataMap["gridData"] = deductionTabValue.gridRows;
      dataMap["reason"] = "Additional Insurance Accrual From Disbursement";
      dataMap["remarks"] = feeDataResponse.otherList.remarks
        ? feeDataResponse.otherList.remarks
        : "";
      dataMap["refDate"] = `${new Date().getDate()}/${
        new Date().getMonth() + 1
      }/${new Date().getFullYear()}`;
      dataMap["referenceNumber"] = feeDataResponse.otherList.referenceNumber
        ? Number(feeDataResponse.otherList.referenceNumber) + 1
        : "1";
      dataMap["updatedBy"] = userName;
      dataMap["applicationNum"] = location.state.applicationNum;
      dataMap["type"] = "accrual";
      dataMap["historyData"] = { historyData };

      const response = await axios.post(
        "/additionalfee/saveFeeDetails",
        dataMap
      );
    }
  };

  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      {!pageloading && (
        <>
          {!viewValue ? (
            <Box style={{ minHeight: "calc(100vh - 120px)" }}>
              <NoSpecialAccess />
            </Box>
          ) : (
            <Box style={{ minHeight: "calc(100vh - 120px)" }}>
              <DisbursementTabIntegrator
                // losData={losData}
                billDayValues={billDayValues}
                deductionTabValue={deductionTabValue}
                setdeductionTabValue={setdeductionTabValue}
                historyData={historyData}
                setHistorydata={setHistorydata}
                disbursementDetailTabValue={disbursementDetailTabValue}
                screenMode="CREATE"
                screenFields={screenFields}
                dispatchEvent={dispatch}
                errordispatchEvent={errorDispatch}
                errorParameters={errorParameters}
                errorState={errorState}
                screenTitle={props.screenTitle}
                parameterValues={parameterValues}
                validateBalanceTransferGrid={validateBalanceTransferGrid}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "8px 0px 8px 0px",
                }}
              >
                <Tooltip title="Ctrl+Z" placement="top">
                  <CustomButton
                    sx={{ height: "2rem" }}
                    variant="contained"
                    disabled={disableCreate}
                    onClick={() => {
                      navigate("/stlap/home/disbursementCreatePortal", {
                        replace: true,
                      });
                    }}
                    ref={backRef}
                  >
                    Back to Search
                  </CustomButton>
                </Tooltip>
                <Tooltip title="Ctrl+S" placement="top">
                  <CustomButton
                    sx={{ height: "2rem", marginLeft: "1%" }}
                    variant="contained"
                    onClick={() => {
                      setLoading(true);
                      setLoadingMsg(
                        "Validating the Disbursement Data for Creation ....."
                      );
                      setTimeout(() => {
                        const dataValues = { ...disbursementDetailTabValue };
                        createRequestHandler(dataValues, losCustomerData);
                      }, 1500);
                    }}
                    disabled={
                      disableCreate ||
                      deleteOperationActive ||
                      losCustomerData?.creditDeviationStatus !== "Approved" ||
                      losCustomerData?.legalDeviationStatus !== "Approved" ||
                      losCustomerData?.techinicalDeviationStatus !==
                        "Approved" ||
                      losCustomerData?.rcuStatus !== "Approved" ||
                      totalDeductionsTabLoadingActive
                    }
                    ref={saveRef}
                  >
                    Create Request
                  </CustomButton>
                </Tooltip>
              </Box>
            </Box>
          )}
          <StlapFooter />
          <CustomConfirmationDialog
            dialogOpen={showConfirmation}
            onDialogClose={() => {
              setshowConfirmation(false);
            }}
            dialogTitle={"Confirmation"}
            dialogContent={"Disbursement Request Create ?"}
            cancelButtonName={"Cancel"}
            hideCancelButton={false}
            okButtonName={"Yes"}
            onOkClick={confirmationOkClickHandler}
          />
          <CustomConfirmationDialog
            dialogOpen={showGeneratedNumber}
            onDialogClose={() => {
              setshowGeneratedNumber(false);
              // const dataValue = { ...disbursementDetailTabValue };
              // dataValue.screenMode = props.screenMode;
              // navigate("/stlap/home/disbursementView", {
              //   state: dataValue,
              // });
              navigate("/stlap/home/disbursementCreatePortal", {
                replace: true,
              });
            }}
            dialogTitle={<Typography>Information</Typography>}
            // dialogContent={"Generated Request Number is :" + requestNumber}
            dialogContent={"Disbursement Request Created Successfully."}
            hideCancelButton={true}
            okButtonName={"OK"}
            onOkClick={() => {
              setshowGeneratedNumber(false);
              processEnach(disbCycleNum, saveData[0]);
              // const dataValue = { ...disbursementDetailTabValue };
              // dataValue.screenMode = props.screenMode;
              // navigate("/stlap/home/disbursementView", {
              //   state: dataValue,
              // });
            }}
          />
          <Snackbar
            open={alert}
            autoHideDuration={6000}
            anchorOrigin={{ vertical, horizontal }}
            onClose={closeAlertHandler}
          >
            <Alert
              onClose={closeAlertHandler}
              severity={alertType}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
        </>
      )}
    </>
  );
};

export default DisbursementCreate;
